export const cart = [
  {
    id: 1,
    title: "Dell E1916HV 18.5 Inch",
    price: 9300,
    quantity: 1,
    stock: 10,
  },
  {
    id: 2,
    title: "Asus Vivobook X515MA",
    price: 35500,
    quantity: 1,
    stock: 8,
  },
  {
    id: 3,
    title: "Canon Eos 4000D 18MP",
    price: 36500,
    quantity: 1,
    stock: 5,
  },
];
